export const albums = [
  {
    album: "stair_shadow_1",
    name: "Stair Shadow No. 1",
    year: 2025,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    series: ["Shadows", "Stairs"],
  },
  {
    album: "stair_shadow_2",
    name: "Stair Shadow No. 2",
    year: 2025,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    series: ["Shadows", "Stairs"],
  },
  {
    album: "cloud_colloseum",
    name: "Cloud Colloseum",
    year: 2025,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    series: ["Clouds", "Arches"],
  },
  {
    album: "cloud_shadow_1",
    name: "Cloud Shadow No. 1",
    year: 2024,
    materials: "canvas & quilt batting",
    size: '18" x 26"',
    price: "sold",
    series: ["Clouds", "Shadows", "Landscapes"],
  },
  {
    album: "cloud_shadow_2",
    name: "Cloud Shadow No. 2",
    year: 2024,
    materials: "canvas & quilt batting",
    size: '18" x 26"',
    series: ["Clouds", "Shadows", "Landscapes"],
  },
  {
    album: "cloud_shadow_3",
    name: "Cloud Shadow No. 3",
    year: 2024,
    materials: "canvas & quilt batting",
    size: '18" x 26"',
    series: ["Clouds", "Shadows", "Arches", "Landscapes"],
  },
  {
    album: "zig_zag",
    name: "Zig Zag",
    year: 2024,
    materials: "canvas & quilt batting",
    size: '16" x 20"',
    series: ["Horizons", "Shadows"],
  },
  {
    album: "arched_interior",
    name: "Arched Interior",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    price: "sold",
    series: ["New Mexico", "Arches"],
  },
  {
    album: "green_door",
    name: "Green Door",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    series: ["New Mexico"],
  },
  {
    album: "double_green_door",
    name: "Double Green Door",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    series: ["New Mexico"],
  },
  {
    album: "adobe_gate",
    name: "Adobe Gate",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    price: "sold",
    series: ["New Mexico"],
  },
  {
    album: "castle_window",
    name: "Castle Window",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: 300,
    series: ["Horizons", "Arches"],
  },
  {
    album: "white_sands_dune",
    name: "White Sands Dune",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '12" x 12"',
    price: "sold",
    series: ["New Mexico", "Landscapes"],
  },
  {
    album: "face_no_1",
    name: "Face No. 1",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: "sold",
    series: ["Faces"],
  },
  {
    album: "face_no_2",
    name: "Face No. 2",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: 350,
    series: ["Faces"],
  },
  {
    album: "face_no_3",
    name: "Face No. 3",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: 350,
    series: ["Faces"],
  },
  {
    album: "doorway_light",
    name: "Doorway Light",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '28.5" x 34"',
    price: "sold",
    series: ["Horizons"],
  },
  {
    album: "shadow_abstraction_1",
    name: "Shadow Abstraction No. 1",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: "sold",
    series: ["Horizons", "Shadows"],
  },
  {
    album: "shadow_abstraction_2",
    name: "Shadow Abstraction No. 2",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: "sold",
    series: ["Horizons", "Shadows"],
  },
  {
    album: "shadow_abstraction_3",
    name: "Shadow Abstraction No. 3",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: 600,
    images: [1, 2, 3],
    series: ["Horizons"],
  },
  {
    album: "arched_stairway",
    name: "Arched Stairway",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '17.5" x 13"',
    price: "sold",
    series: ["Stairs", "Arches"],
  },
  {
    album: "arch_shadow",
    name: "Arch Shadow",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: 600,
    series: ["Horizons", "Arches", "Shadows"],
  },
  {
    album: "cloud_field",
    name: "Cloud Fields",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: 900,
    images: [1, 2, 3],
    series: ["Clouds", "Landscapes"],
  },
  {
    album: "gateways",
    name: "Gateways",
    year: 2023,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: 300,
    series: ["Horizons"],
  },
  {
    album: "9_three_columns_2022",
    name: "Three Columns",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: 300,
    series: ["Horizons"],
  },
  {
    album: "6_triple_arch_2022",
    name: "Triple Arch",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: "sold",
    series: ["Horizons", "Arches"],
  },
  {
    album: "7_iso_square_2022",
    name: "Isometric Square No. 2",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: "sold",
    series: ["Horizons", "Arches"],
  },
  {
    album: "10_walled_arch_2022",
    name: "Walled Arch",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: 300,
    series: ["Horizons", "Arches"],
  },
  {
    album: "8_view_point_2022",
    name: "View Point",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '11" x 14"',
    price: "sold",
    series: ["Horizons"],
  },
  {
    album: "5_large_arch_2022",
    name: "Large Arch",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '24" x 34"',
    price: "sold",
    series: ["Horizons", "Arches", "Shadows"],
  },
  {
    album: "4_columns_2022",
    name: "Columns",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '17" x 25"',
    price: 350,
    series: ["Horizons"],
  },
  {
    album: "3_arches_2022",
    name: "Arches",
    year: 2022,
    materials: "canvas & quilt batting",
    size: '12" x 23"',
    price: 300,
    series: ["Horizons", "Arches"],
  },
  {
    album: "2_faces_2021",
    name: "Faces",
    year: 2021,
    materials: "canvas & quilt batting",
    size: '14" x 14"',
    price: "sold",
    series: ["Faces"],
  },
  {
    album: "1_square_2020",
    name: "Isometric Square No. 1",
    year: 2020,
    materials: "canvas & quilt batting",
    size: '12" x 15"',
    price: "sold",
    series: ["Horizons"],
  },
];

export const getSeries = () => {
  const series = new Set();
  for (const album of albums) {
    for (const s of album.series) {
      series.add(s);
    }
  }
  return Array.from(series);
};

export const getFilteredAlbums = (currentSeries) => {
  const years = new Set();
  const albumsByYear = {};

  for (const album of albums) {
    if (!currentSeries || album.series.indexOf(currentSeries) >= 0) {
      years.add(album.year);
      if (albumsByYear[album.year] === undefined) {
        albumsByYear[album.year] = [];
      }
      albumsByYear[album.year].push(album);
    }
  }

  return {
    years: Array.from(years),
    albumsByYear,
  };
};
